






































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {InputResponsavelUsuarioSchema} from '@/schema/resource/ResponsavelUsuario/InputResponsavelUsuarioSchema'
import {ResponsavelUsuario} from '@/model/resource/ResponsavelUsuario'

@Component
export default class PersistResponsavelUsuarioView extends Vue {
  @Prop() id1?: string
  @Prop() id2?: string

  @Provide('validator') validator = this.$validator

  schema = new InputResponsavelUsuarioSchema()
  responsavelUsuario = new ResponsavelUsuario()

  async created() {
    this.responsavelUsuario.ehCriacao = !Number(this.id2)
    await this.populate()
  }

  async populate() {
    const id = Number(this.id2) || null

    if (id) {
      await this.responsavelUsuario.getResponsavelUsuario(id)
    }

    $.await.done('getResponsavelUsuario')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    this.responsavelUsuario.idResponsavelFk = Number(this.id1)

    if (this.responsavelUsuario.senha)
      this.responsavelUsuario.ehSenhaTemporaria = true

    await this.responsavelUsuario.persistResponsavelUsuario()
    await Helper.successAndPush(
      'system.success.persist',
      `/responsavel-usuario/list/${this.id1}`
    )
  }

  get title() {
    return Number(this.id2)
      ? this.$t('resource.ResponsavelUsuario.edit')
      : this.$t('resource.ResponsavelUsuario.new')
  }
}
